<template>
  <Container type="card-full">
    <div slot="header">
      <el-button v-if="type === 1 || type === 2" @click="save(true)" :loading="btnLoading">保存</el-button>
      <el-button  @click="close">关闭</el-button>
    </div>
    <div>
      <el-form :model="rmivd" label-position="left" label-width="60px">
        <el-row>
          <el-col :span="5">
            <el-form-item label="单号">
              <el-input v-model="rmivd.rmivdno" :maxlength="20" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="margin-left: -50px;" >
            <el-form-item label="" v-if="type !== 1" >
              <doc-status :form="{docid: rmivd.rmivdid,doctid: rmivd.rmivddoctid,
                                    docno: rmivd.rmivdno, docdate: rmivd.rmivddate,
                                    docstatcheckstatusname:rmivd.docstatcheckstatusname,
                                    docstatnextcheckdesc:rmivd.docstatnextcheckdesc,
                                    returnForm:'rmivdForm'}"></doc-status>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item label="供应商">
              <el-select v-model="rmivd.rmivdcvid" :clearable="true" :disabled="disable">
                <el-option v-for="(item, index) in cvList" :label="item.cvname" :value="item.cvid" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" style="margin-left: 80px;">
            <el-form-item label="日期">
              <el-date-picker v-model="rmivd.rmivddate" type="date" placeholder="选择日期" :disabled="disable"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="15">
            <el-form-item label="备注">
              <el-input v-model="rmivd.rmivdremark" :maxlength="255" type="textarea" :disabled="disable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <vggrid ref="xGrid" :list="list" tableheight="500" flexname="rmivditemflex"
              :cols="cols" :showfooter="true" :showPage="false" :resizable="true"
              :needSelection="false" :needRowNum="true"
              :needBlackRow="true" :needPopMenu="true" :canbeEdit="!disable"
              @cellClick="cellClick" @editActived="cellActived"
              @gendoc="gendoc">
      </vggrid>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  import DocthIndex from "../common/docthIndex";
  import DocStatus from "../common/docStatus.vue";
  export default {
    name: "rmivdform",
    data () {
      return {
        rmivd: this.$route.params.form,
        rmivditem: {},
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 || this.$route.params.form.docstatcheckval !==1 ? true : false,
        btnLoading: false,
        cvList: [],
        unitList: [],
        lcList: [],
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'rmivditemlebcid', fieldtype: 'C', hide: 1, title: '货物编码ID',calculExpr:''},
          { field: 'lebccode', fieldtype: 'C', brows: 'lebc',getvaluestr: ['lebcid','lebccode','lebcname','unitid'],setvaluestr: ['rmivditemlebcid','lebccode','lebcname','rmivditemunitid'], title: '货物编码',calculExpr:'',editRender: { name: 'ElInput', props: { readonly: true, suffixIcon: 'el-icon-search'}}},
          { field: 'lebcname', fieldtype: 'C',  title: '货物名称',calculExpr:''},
          { field: 'rmivditemunitid', fieldtype: 'C',  title: '计量单位',calculExpr:'',editRender: { name: 'ElSelect', options: this.unitList}},
          { field: 'rmivditemlcid', fieldtype: 'C',  title: '仓库',calculExpr:'',editRender: { name: 'ElSelect', options: this.lcList}},
          { field: 'rmivditemqty', fieldtype: 'F',  triggercol:1, title: '数量', issum: true,calculExpr:'',editRender: { name: 'input'}},
          { field: 'rmivditemprice', fieldtype: 'F',  triggercol:1, title: '单价',calculExpr:'',editRender: { name: 'input'}},
          { field: 'rmivditemamt', fieldtype: 'F',  title: '金额', issum: true,calculExpr:'rmivditemqty*rmivditemprice'},
          { field: 'rmivditemremark', fieldtype: 'C',  title: '备注',calculExpr:'',editRender: { name: 'input'}}
        ]
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getCvList()
      this.getRmivdItemList()
    },
    mounted () {
    },
    watch: {
    },
    filters: {
    },
    components: {
      DocStatus,
      DocthIndex,
      vggrid},
    methods: {
      async init() {
        this.rmivd = this.$route.params.form
        this.rmivd.userid = this.$store.getters.loginUser.userid
        this.rmivditem = {}
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 || this.$route.params.form.docstatcheckval !==1 ? true : false
        this.btnLoading = false
        this.cvList = []
        this.unitList = []
        this.lcList = []
        this.list = []
      },
      async getCvList () {
        this.cvList = await request({
          method: 'get',
          url: '/basic/cv/getCvList',
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
      },
      async cellActived (row) {
      },
      async gendoc(docgencode) {
        await this.save(false)
        let form = {
          docform: this.rmivd,
          flexname: 'rmivditemflex',
          docgencode: docgencode,
          returnForm: 'rmivdForm',
          savepath: '/cggl/rmivd/addOrEdit'
        }
        this.$router.push({name: 'docgenForm', params: {form: form}})
      },
      async cellClick (row) {
        this.rmivditem = row.row
      },
      async getRmivdItemList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/cggl/rmivd/getRmivdItemList',
          params: {rmivdid: this.rmivd.rmivdid}
        })
        this.list = res
        this.loading = false
      },
      async getFmon() {
        let data = await request({
          method: 'get',
          url: '/basic/fc/getFmonByDate',
          params: {comid: this.$store.getters.loginUser.usercomid,docdate: this.rmivd.rmivddate}
        })
        if (data.issuccess ===1) {
          this.rmivd.rmivdfmon = data.data.fcfmon
        } else {
          this.$message.error(data.msg)
          return
        }
      },
      async save (returnflg) {
        await this.getFmon()
        let model = {
          dochead: this.rmivd,
          docitems: this.$refs.xGrid.$refs.xGrid.getRecordset()
        }
        await this.addOrEdit(model,returnflg)
      },
      async addOrEdit (model,returnflg) {
        let data = await request({
          url: '/cggl/rmivd/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.rmivd.rmivdid = data.data.rmivdid
          if (returnflg) {
            this.close()
            this.$message.success('保存成功')
          }
        } else {
          this.$message.error('保存失败')
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'rmivdIndex'})
      }
    }
  }
</script>

<style scoped>

</style>
